// extracted by mini-css-extract-plugin
module.exports = {"date":"ProcedureTableInfo_date__1b77k","head":"ProcedureTableInfo_head__S8MP9"};